__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/80f9ed4/packs/";